import styleInject from '../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ListScroll_x__tSPeG{width:100%}.ListScroll_y__mvFCU{height:100%}";
var S = {"x":"ListScroll_x__tSPeG","y":"ListScroll_y__mvFCU"};
styleInject(css_248z);

export { S as default };
